'use strict';

module.exports = require('./dist/openchemlib-minimal');
